import axios from "axios";

export default function EntryzoneWorktypeAddService(formData, entryzoneId) {
  return axios({
    method: 'post',
    url: process.env.REACT_APP_API_HOST + "/entry_zone/" + entryzoneId + "/workTypes",
    data: formData,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
